(() => {
  'use strict';
  const root = document.querySelector('[data-trio-page]');
  if (!root) return;
  const $ = s => root.querySelector(s), $$ = s => [...root.querySelectorAll(s)];
  const config = JSON.parse($('[data-trio-config]').textContent);
  const variants = JSON.parse($('[data-trio-variants]').textContent);
  const currency = JSON.parse($('[data-trio-currency]').textContent);
  const initial = JSON.parse($('[data-trio-selected]').textContent);
  const form = $('[data-trio-form]'), status = $('[data-status]'), loading = $('[data-loading]');
  const base = window.Shopify?.routes?.root || '/';
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style: 'currency', currency}).format(cents / 100);
  let selected = variants.find(v => v.id === initial), busy = false, saved = false, pending = null;
  let photo = null, photoURL = null, photoImage = null, crop = null, readVersion = 0, redirectTimer = null;
  const reference = () => 'TL-' + config.key.toUpperCase() + '-' + (crypto.randomUUID ? crypto.randomUUID() : Date.now() + '-' + Math.random().toString(16).slice(2));
  $('[data-design-reference]').value = reference();
  function option() { return config.variants.find(o => o.id === selected.id); }
  function changeDesign() {
    if (pending) return;
    $('[data-design-reference]').value = reference(); saved = false;
    if ($('[data-crop-checked]')) $('[data-crop-checked]').checked = false;
    $('[data-saved]').hidden = true; updateButtons();
  }
  function updateButtons() { $$('button[type="submit"]').forEach(b => b.disabled = busy || saved || !selected?.available); }
  function showPhoto(src, alt, small) {
    const img = $('[data-hero]'); img.src = src; img.alt = alt;
    img.srcset = small ? small + ' 600w, ' + src + ' 1200w' : '';
    $$('[data-photo]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.photo === src)));
  }
  function showOptionPhoto() {
    const o = option(), label = $('[name="trio-variant"][value="' + selected.id + '"]').closest('label');
    const small = label.querySelector('img').src, full = small.replace('-600.webp', '.webp');
    showPhoto(full, o.label + ' - ' + o.detail, small);
  }
  function update() {
    form.elements.id.value = String(selected.id);
    $$('[name="trio-variant"]').forEach(i => i.checked = Number(i.value) === selected.id);
    const qty = Number(form.elements.quantity.value), cents = selected.price * qty;
    // Shopify's native percentage allocation rounds the discount down per unit.
    const total = config.custom && qty >= 2 ? (selected.price - Math.floor(selected.price * .1)) * qty : cents;
    $('[data-price]').textContent = money(selected.price);
    $('[data-order-total]').textContent = money(total) + ' total' + (total < cents ? ' · save 10%' : '');
    const compare = $('[data-compare]'); compare.hidden = !(selected.compare_at_price > selected.price);
    compare.textContent = selected.compare_at_price ? money(selected.compare_at_price) : '';
    $('[data-sticky-label]').textContent = option().label;
    $('[data-sticky-price]').textContent = money(selected.price);
    $('[data-sticky-image]').src = $('[name="trio-variant"][value="' + selected.id + '"]').closest('label').querySelector('img').src;
    const url = new URL(location.href); url.searchParams.set('variant', selected.id); history.replaceState({}, '', url);
    renderCrop(); updateButtons();
  }
  $$('[name="trio-variant"]').forEach(i => i.addEventListener('change', () => {
    if (busy || pending) return;
    const next = variants.find(v => v.id === Number(i.value)); if (!next?.available) return;
    selected = next; changeDesign(); update(); showOptionPhoto();
  }));
  form.elements.quantity.addEventListener('change', () => { changeDesign(); update(); });
  $$('[data-photo]').forEach(b => b.addEventListener('click', () => showPhoto(b.dataset.photo, b.dataset.alt, b.dataset.photoSmall)));
  $('[data-open-photo]').addEventListener('click', () => { const d = $('[data-lightbox]'), img = d.querySelector('img'); img.src = $('[data-hero]').src; img.alt = $('[data-hero]').alt; d.showModal(); });
  $('[data-close-photo]').addEventListener('click', () => $('[data-lightbox]').close());
  $('[data-lightbox]').addEventListener('click', e => { if (e.target === $('[data-lightbox]')) $('[data-lightbox]').close(); });
  function cropGeometry() {
    if (!photoImage) return null;
    let ratio = config.key === 'necklace' ? 1 : option().width / option().height;
    if ($('[data-orientation]')?.value === 'landscape') ratio = 1 / ratio;
    const iw = photoImage.naturalWidth, ih = photoImage.naturalHeight;
    let w = iw, h = w / ratio; if (h > ih) { h = ih; w = h * ratio; }
    const zoom = Number($('[data-crop-zoom]').value) / 100; w /= zoom; h /= zoom;
    const x = (iw - w) * Number($('[data-crop-x]').value) / 100;
    const y = (ih - h) * Number($('[data-crop-y]').value) / 100;
    return {x, y, w, h, ratio, sourceWidth: iw, sourceHeight: ih};
  }
  function renderCrop() {
    if (!photoImage) return;
    crop = cropGeometry(); const canvas = $('[data-crop-canvas]');
    canvas.width = 600; canvas.height = Math.round(600 / crop.ratio);
    $('[data-crop-stage]').style.aspectRatio = String(crop.ratio);
    canvas.getContext('2d').drawImage(photoImage, crop.x, crop.y, crop.w, crop.h, 0, 0, canvas.width, canvas.height);
  }
  function clearPhoto() {
    readVersion++; if (photoURL) URL.revokeObjectURL(photoURL);
    photo = null; photoURL = null; photoImage = null; crop = null;
    const input = $('#TrioPhoto'); input.value = ''; input.setCustomValidity('');
    $('[data-crop-wrap]').hidden = true; $('[data-file-note]').textContent = 'Choose a clear original. We keep it with your order.';
    changeDesign();
  }
  if (config.custom) {
    const input = $('#TrioPhoto');
    input.addEventListener('change', async () => {
      if (pending) return;
      const file = input.files?.[0], version = ++readVersion;
      input.setCustomValidity(''); photoImage = null; photo = null; crop = null; $('[data-crop-wrap]').hidden = true;
      if (photoURL) URL.revokeObjectURL(photoURL); photoURL = null;
      if (!file) { changeDesign(); return; }
      if (!/^image\/(jpeg|png|webp)$/.test(file.type) || file.size > 20 * 1024 * 1024 || !file.size) {
        input.value = ''; input.setCustomValidity('Choose a JPEG, PNG or WebP image no larger than 20 MB. On iPhone, export HEIC photos as JPEG first.');
        $('[data-file-note]').textContent = input.validationMessage; input.reportValidity(); return;
      }
      $('[data-file-note]').textContent = 'Opening your photo…';
      const url = URL.createObjectURL(file); photoURL = url; const img = new Image();
      img.onload = () => {
        if (version !== readVersion) return;
        photoImage = img; photo = file; $('[data-crop-wrap]').hidden = false;
        $('[data-crop-x]').value = '50'; $('[data-crop-y]').value = '50'; $('[data-crop-zoom]').value = '100';
        if ($('[data-orientation]')) $('[data-orientation]').value = img.naturalWidth > img.naturalHeight ? 'landscape' : 'portrait';
        $('[data-file-note]').textContent = file.name + ' · ' + img.naturalWidth + ' x ' + img.naturalHeight + ' px' + (Math.min(img.naturalWidth, img.naturalHeight) < 800 ? ' · A larger original will give more print detail.' : '');
        changeDesign(); renderCrop();
      };
      img.onerror = () => { if (version !== readVersion) return; input.value = ''; input.setCustomValidity('This image could not be opened. Please choose another JPEG, PNG or WebP.'); $('[data-file-note]').textContent = input.validationMessage; };
      img.src = url;
    });
    $('[data-remove-photo]').addEventListener('click', clearPhoto);
    ['[data-crop-x]', '[data-crop-y]', '[data-crop-zoom]', '[data-orientation]'].forEach(s => $(s)?.addEventListener('input', () => { changeDesign(); renderCrop(); }));
    form.querySelector('textarea').addEventListener('input', changeDesign);
    $('[data-new-design]').addEventListener('click', () => {
      if (pending || busy) return; clearPhoto(); form.querySelector('textarea').value = ''; form.elements.quantity.value = '1';
      status.textContent = 'Ready for another design. Your previous item stays in your bag.'; update();
      form.scrollIntoView({block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    });
  }
  async function printFile() {
    const g = cropGeometry(); if (!g) throw Error('Please wait for your photo to finish opening.');
    const scale = Math.min(1, 4096 / g.w, 4096 / g.h, Math.sqrt(12000000 / (g.w * g.h)));
    const canvas = document.createElement('canvas'); canvas.width = Math.max(1, Math.round(g.w * scale)); canvas.height = Math.max(1, Math.round(g.h * scale));
    canvas.getContext('2d').drawImage(photoImage, g.x, g.y, g.w, g.h, 0, 0, canvas.width, canvas.height);
    const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png'));
    if (!blob?.size) throw Error('The print preview could not be prepared. Please try a smaller photo.');
    return {file: new File([blob], 'TENLOVE-' + config.key + '-print.png', {type: 'image/png'}), geometry: g, width: canvas.width, height: canvas.height};
  }
  const step = text => { $('[data-loading-step]').textContent = text; };
  function openLoading() { if (!loading.open) loading.showModal(); $('[data-continue-checkout]').hidden = true; step('Preparing your item…'); }
  function closeLoading() { if (loading.open) loading.close(); clearTimeout(redirectTimer); }
  loading.addEventListener('cancel', e => { if (busy) e.preventDefault(); });
  async function request(url, options = {}, timeout = 120000) {
    const controller = new AbortController(), timer = setTimeout(() => controller.abort(), timeout);
    try {
      const response = await fetch(url, {...options, signal: controller.signal, credentials: 'same-origin', headers: {Accept: 'application/json', ...options.headers}});
      const data = await response.json();
      if (!response.ok) { const error = Error(typeof data.description === 'string' ? data.description : 'We could not save this item. Please try again.'); error.confirmedRejected = true; throw error; }
      return data;
    } finally { clearTimeout(timer); }
  }
  function validateItem(item, intent) {
    if (Number(item.variant_id || item.id) !== intent.variant || Number(item.quantity) !== intent.quantity) throw Error('Your saved option needs a check. Please retry before checkout.');
    if (item.properties?.['Design reference'] !== intent.reference) throw Error('The saved design reference does not match. Please contact us.');
    if (config.custom) for (const name of ['Photo1', 'Approved print file']) {
      const value = item.properties?.[name];
      if (typeof value !== 'string' || !/^https:\/\//.test(value)) throw Error('Both photo files must finish saving before checkout. Retry to finish this same design, without adding another item.');
    }
  }
  async function findSaved(intent) {
    const cart = await request(base + 'cart.js', {}, 20000);
    const found = cart.items.find(i => i.properties?.['Design reference'] === intent.reference);
    if (found) validateItem(found, intent); return {found, cart};
  }
  function lockControls(lock) {
    $$('fieldset,select,textarea').forEach(e => e.disabled = lock);
  }
  form.addEventListener('submit', async event => {
    event.preventDefault(); event.stopImmediatePropagation();
    if (busy || saved || !selected?.available) return;
    const checkout = event.submitter?.value === 'checkout';
    if (!pending && !form.reportValidity()) return;
    if (!pending && config.custom && (!photo || !photoImage)) { status.textContent = 'Please wait for your photo to finish opening.'; return; }
    busy = true; updateButtons(); openLoading(); form.setAttribute('aria-busy', 'true');
    let navigation = false;
    try {
      if (!pending) {
        const data = new FormData(form); data.delete('trio-variant'); data.delete('intent');
        const ref = $('[data-design-reference]').value;
        data.set('properties[Selected option]', option().label + ' · ' + option().detail);
        data.set('properties[Product format]', config.custom ? (config.key === 'blanket' ? 'Photo printed on blanket; no cartoon conversion' : 'Photo insert inside camera-shaped necklace') : 'Manual wooden dog scratch board');
        if (config.custom) {
          step('Preparing your chosen print crop…');
          const print = await printFile(); data.set('properties[Photo1]', photo, photo.name);
          data.set('properties[Approved print file]', print.file, print.file.name);
          data.set('properties[Photo filename]', photo.name);
          data.set('properties[Print dimensions]', print.width + ' x ' + print.height + ' px');
          data.set('properties[Crop approved]', 'Yes - customer checked the on-page crop');
          data.set('properties[_Crop geometry]', JSON.stringify(print.geometry));
          data.set('properties[_Print instruction]', config.key === 'necklace' ? 'Print this exact crop in the circular photo insert. Do not change the image or substitute a sample. Circle guide shown to customer.' : 'Print this exact crop including its background. Do not cartoonize, remove background or substitute a sample.');
        }
        pending = {data, reference: ref, variant: selected.id, quantity: Number(form.elements.quantity.value)};
      }
      lockControls(true); step(config.custom ? 'Saving your original photo and print file…' : 'Saving your board…');
      let {found, cart} = await findSaved(pending), newlyAdded = false;
      if (!found) {
        try {
          found = await request(base + 'cart/add.js', {method: 'POST', body: pending.data});
          validateItem(found, pending);
          newlyAdded = true;
        } catch (error) {
          if (error.confirmedRejected) { pending = null; throw error; }
          step('Checking whether your item has already saved…');
          const reconciled = await findSaved(pending); found = reconciled.found; cart = reconciled.cart;
          if (!found) throw Error('The connection was interrupted. Retry to finish saving this same design. We will check your bag first to avoid adding it twice.');
        }
      }
      validateItem(found, pending);
      const addedQuantity = newlyAdded ? pending.quantity : 0;
      const eligibleQuantity = (cart?.items || []).filter(i => config.pairProductIds?.includes(Number(i.product_id))).reduce((n, i) => n + i.quantity, 0) + (config.custom ? addedQuantity : 0);
      const existingCodes = (cart?.discount_codes || []).map(c => typeof c === 'string' ? c : c.code).filter(Boolean);
      const codes = [...new Set([...existingCodes, ...(config.custom && eligibleQuantity >= 2 ? [config.pairCode] : [])])];
      const checkoutURL = codes.length ? base + 'discount/' + codes.map(encodeURIComponent).join(',') + '?redirect=' + encodeURIComponent(base + 'checkout') : base + 'checkout';
      const bagURL = codes.length ? base + 'discount/' + codes.map(encodeURIComponent).join(',') + '?redirect=' + encodeURIComponent(base + 'cart') : base + 'cart';
      saved = true; pending = null;
      $('[data-saved]').hidden = false; status.textContent = config.custom ? 'Both your original photo and approved print crop are saved with this item.' : 'Your board is saved in your bag.';
      $('[data-bag-count]').textContent = String((cart?.item_count || 0) + addedQuantity);
      $('[data-saved] a').href = bagURL;
      if (codes.length && !checkout) {
        // Coupon acknowledgement is never a condition for keeping already-saved photo files.
        await request(base + 'cart/update.js', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({discount: codes.join(',')})}, 2000).catch(() => null);
      }
      if (checkout) {
        navigation = true; step('Your item is saved. Opening secure checkout…');
        const link = $('[data-continue-checkout]'); link.href = checkoutURL;
        redirectTimer = setTimeout(() => { link.hidden = false; }, 10000);
        location.assign(checkoutURL);
      }
    } catch (error) {
      status.textContent = error.name === 'AbortError' ? 'The connection took too long. Retry to finish saving the same item; we will check your bag before adding it again.' : error.message;
    } finally {
      if (!navigation) { busy = false; form.removeAttribute('aria-busy'); lockControls(Boolean(pending)); updateButtons(); closeLoading(); }
    }
  }, true);
  window.addEventListener('pageshow', event => { if (event.persisted) { busy = false; form.removeAttribute('aria-busy'); closeLoading(); lockControls(Boolean(pending)); updateButtons(); } });
  $('[data-print-guide]')?.addEventListener('click', () => window.print());
  if ('IntersectionObserver' in window) new IntersectionObserver(([entry]) => { $('[data-sticky]').hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0; }).observe($('[data-buy]'));
  update();
  if (new URL(location.href).searchParams.has('variant') && Number(initial) !== config.defaultId) showOptionPhoto();
  root.dataset.ready = 'true';
})();
